import { useEffect, useState } from 'react';

/**
 * `navigator.onLine` plus the `online`/`offline` events (`AM-132 point 13`, D17, ISO-18): the PWA
 * promises no offline work, so the UI only needs to know when to say so and to stop the controls
 * that would otherwise fail silently.
 */
export function useOnline(): boolean {
  const [online, setOnline] = useState(() =>
    typeof navigator === 'undefined' ? true : navigator.onLine,
  );

  useEffect(() => {
    function handleOnline() {
      setOnline(true);
    }
    function handleOffline() {
      setOnline(false);
    }

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return online;
}
